import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "About", href: "#about", id: "nav-about" },
  { label: "Services", href: "#services", id: "nav-services" },
  { label: "Industries", href: "#industries", id: "nav-industries" },
  { label: "EdKonect", href: "#products", id: "nav-products" },
  { label: "Grubpe", href: "#grubpe", id: "nav-grubpe" },
  { label: "Clients", href: "#clients", id: "nav-clients" },
  { label: "Stack", href: "#technologies", id: "nav-technologies" },
  { label: "Team", href: "#team", id: "nav-team" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-[#e5e5e5]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <a
          href="#home"
          data-testid="navbar-logo"
          className="flex items-center gap-2"
        >
          <span className="font-display text-2xl font-black tracking-tighter text-[#0a0a0a]">
            Intelvolks
          </span>
          <span className="block w-2 h-2 bg-[#0038FF]" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              data-testid={item.id}
              className="iv-link text-sm font-medium text-[#0a0a0a]"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="navbar-cta"
            className="hidden md:inline-flex items-center bg-[#0a0a0a] text-white px-5 py-2.5 text-sm font-semibold uppercase tracking-wider hover:bg-[#0038FF] transition-colors duration-300"
          >
            Contact
          </a>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 text-[#0a0a0a]"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#e5e5e5] bg-white"
        >
          <div className="px-4 py-6 flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={item.href}
                data-testid={`mobile-${item.id}`}
                onClick={() => setMobileOpen(false)}
                className="text-base font-medium text-[#0a0a0a]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="mobile-navbar-cta"
              onClick={() => setMobileOpen(false)}
              className="mt-2 inline-flex items-center justify-center bg-[#0a0a0a] text-white px-5 py-3 text-sm font-semibold uppercase tracking-wider"
            >
              Contact
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
